//TODO： 如对于字符串操作过多，考虑引入第三方开源库
export function getDataType(data) {
  let type = Object.prototype.toString.call(data);
  type = type.slice(8, -1);
  return type;
}

export function trimData(data) {
  if (typeof data === 'string') {
    return data.trim();
  } else {
    return data;
  }
}

export function toNum(value) {
  let newValue = Number(value);
  if (isNaN(newValue)) {
    return 0;
  } else {
    return newValue;
  }
}

export function getRate(value1, value2) {
  value1 = Number(value1);
  value2 = Number(value2);
  if (isNaN(value1) || isNaN(value2)) {
    return '';
  }
  if (value2 === 0) {
    return '';
  }
  let rate = (value1 / value2) * 100;
  rate = rate.toFixed(2);
  rate = Number(rate);
  return rate;
}

/*
 * value1 被除数
 * value2 除数
 * decimal 保留小数
 * */
export function divideNum(value1, value2, decimal = 2) {
  if (value2 === 0) {
    return 0;
  }
  const resStr = (value1 / value2).toFixed(decimal);
  const resNum = Number(resStr);
  return resNum;
}

// 格式化数字 防止小数点过长
export function formatNum(num, decimal = 2) {
  return Number(num.toFixed(decimal));
}

export function paramsToUrl(obj) {
  let keys = Object.keys(obj);
  let url = '?';
  keys.forEach((key, index) => {
    let paramStr = '';
    if (index === keys.length - 1) {
      paramStr = `${key}=${obj[key]}`;
    } else {
      paramStr = `${key}=${obj[key]}&`;
    }
    url += paramStr;
  });
  return url;
}

export function urlToParams(url) {
  let index = url.indexOf('?');
  if (index > -1) {
    let searchUrl = url.slice(index + 1);
    if (searchUrl) {
      let params = {};
      let paramsUrls = searchUrl.split('&');
      paramsUrls.forEach((paramsUrl) => {
        let keyValues = paramsUrl.split('=');
        let key = keyValues[0];
        let value = decodeURIComponent(keyValues[1] || '');
        params[key] = value;
      });
      return params;
    }else{
      return {}
    }
  }
  return {};
}

export function getThousandNum(num) {
  if (num) {
    return num.toString().replace(/\d+/, function (n) {
      // 先提取整数部分
      return n.replace(/(\d)(?=(\d{3})+$)/g, function ($1) {
        // 对整数部分添加分隔符
        return $1 + ',';
      });
    });
  }
  return '';
}
